export default "__VITE_ASSET__BmXKwN6k__"